//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return { query: "" };
	},
	props: {
		model: { required: false },
	},
	computed: {
		propModel: {
			get() {
				return this.prop;
			},
			set(value) {
				this.$emit("update:prop", value);
			},
		},
	},
};
